// スペシャルWikiリスト
export const special_wiki_list:string[] = [
    "maitetsu_bkmt"
];

// バンされたWikiリスト
export const ban_wiki_list:string[] = [];

// 退会されたWikiリスト(手動で更新する)
export const deleted_wiki_list:string[] = [];